<template>
   <div id="removefrom">
      <el-tabs v-model="soldGoodsQueryPageDto.goodsType" @tab-click="handleClick">
           <el-tab-pane
           v-for="item in tabList"
           :key="item.name"
           :label="item.label"
           :name="item.name"
         >
         </el-tab-pane>
         <div class="tos">
             <el-form :inline="true" :model="soldGoodsQueryPageDto" label-width="100px">
                <el-form-item label="关键字：">
                   <el-input v-model="soldGoodsQueryPageDto.keyWords"></el-input>
                </el-form-item>
                <el-form-item label="产品分类：">
                     <el-select v-model="soldGoodsQueryPageDto.cateId" clearable placeholder="请选择产品分类">
                     <el-option
                        v-for="item in fjfltableData"
                        :key="item.cateId"
                        :label="item.cateName"
                        :value="item.cateId"
                     >
                     </el-option>
                     </el-select>
               </el-form-item>
                <el-form-item>
                   <el-button type="primary" plain @click="sjhsearchFor()">查询</el-button>
                </el-form-item>
             </el-form>
             <div class="right-item">
               <el-button  type="warning" :disabled = dataSet @click=newoktypes()>批量上架</el-button>
            </div>
          </div>
          <div class="tjannos">
         </div>
          <div class="tableform">
            <el-table
                :data="tableData"
                border
                stripe
                @selection-change="plhandleClick"
                :cell-style="{'text-align':'center'}"
                :header-cell-style="{'background-color': '#eef1f6','text-align':'center'}"
                style="width: 100%">
                <el-table-column
                  type="selection"
                  width="55">
               </el-table-column>
                <el-table-column
                   prop="goodsName"
                   label="名称"
                   >
                   <template slot-scope="{row:{ goodsName }}">
                   {{ goodsName|| "—" }}
                   </template>
                </el-table-column>
                <el-table-column
                   prop="priceRange"
                   label="售价范围"
                   >
                   <template slot-scope="{row:{ priceRange }}">
                   {{ priceRange|| "—" }}
                   </template>
                </el-table-column>
                <!-- <el-table-column
                   prop="status"
                   label="状态"
                   >
                   <template slot-scope="{row:{ status }}">
                   {{ status|| "—" }}
                   </template>
                </el-table-column> -->
                <el-table-column
                   prop="goodsDesc"
                   label="说明"
                   show-overflow-tooltip
                   >
                   <template slot-scope="{row:{ goodsDesc }}">
                   {{ goodsDesc|| "—" }}
                   </template>
                </el-table-column>
                <!-- <el-table-column
                   prop="specificationValues"
                   label="售价范围"
                   >
                   <template slot-scope="scope">
                     <span v-for="(item, index) in scope.row.specificationValues" :key="index">
                              <span>{{ item.specificationValue }}，</span>
                           </span>
                   </template>
                </el-table-column> -->
                <el-table-column fixed="right" label="操作" width="280">
                   <template slot-scope="scope">
                         <i title="编辑" class="el-icon-alixiugai" v-if="scope.row.goodsType == '0'" style="color: #1296db;cursor: pointer;"  @click=bianjiClick(scope.row) ></i>
                         <i title="编辑" class="el-icon-alixiugai" v-else style="color: #1296db;cursor: pointer;"  @click=xjpjbianjiClick(scope.row) ></i>
                         <i title="删除" class="el-icon-alishanchu" style="color: #d81e06;cursor: pointer;"  @click=dels(scope.row) ></i>
                   </template>
                </el-table-column>
             </el-table>
             <div class="btnbox">
                <el-pagination
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   :current-page="soldGoodsQueryPageDto.pageNum"
                   :page-sizes="[10, 15, 20]"
                   :page-size="soldGoodsQueryPageDto.pageSize"
                   layout="total, sizes, prev, pager, next, jumper"
                   :total="this.totals">
                </el-pagination>
             </div>
          </div>
        </el-tabs>
   </div>
   </template>
   <script>
      export default {
      name:'removefrom',
      data(){
       return{
         soldGoodsQueryPageDto:{
            pageNum:1,
            pageSize:10,
            keyWords:null,
            cateId:null,
            goodsType:'0',
         },
         tabList: [
            {
               label: '产品列表',
               name: '0',
            },
            {
               label: '配件列表',
               name: '1',
            },
         ],
         tableData: [],
         totals:10,
         increase:false,
         zcrules: {
            userName: [
            { required: true, message: '请输入账号', trigger: 'blur' },
            // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
            ],
         },
         specificationspltjgg: {
            cateDesc: null,
            cateName: null,
            specificationCateId: null,
            specificationsAddDtos: [
               {
               specificationValue:null
            }]
         },
         serviceTypeDto:{
            cateDesc:null,
            cateName:null,
            specificationCateId:null,
         },
         rules: {
            cateName: [
            { required: true, message: '请输入规格名称', trigger: 'change' }
            ]
         },
         specificationsId:null,
         fjfltableData:[],
         categoryPageDto:{
          cateType:null,
          parentCateId:null,
          cateName:null,
        },
        upGoodsBatchDto:{
         goodsIds:[],
         goodsType:null
        },
        dataSet:true,
       }
      },
      created(){
         this.getlist(this.soldGoodsQueryPageDto)
      },
      mounted(){
         this.cpflgetlist()
      },
      methods:{
         cpflgetlist() {
            this.$api.cplbbfyqueryList({
               cateType:this.soldGoodsQueryPageDto.goodsType,
               parentCateId:null,
               cateName:null,
            })
            .then((res) => {
                  if (res.data.code == 200) {
                     this.fjfltableData = res.data.data
                  } else {
                     this.$message.error(res.data.message)
                  }
            })
         },
         getlist(soldGoodsQueryPageDto) {
            this.$api.querySoldOutPage(soldGoodsQueryPageDto)
            .then((res) => {
            if (res.data.code == 200) {
               this.tableData = res.data.data.records
               this.totals = res.data.data.total
            } else {
            this.$message.error(res.data.message)
            }
            })
         },
         handleClick(tab, event) {
            this.soldGoodsQueryPageDto.goodsType = tab.name
            this.getlist(this.soldGoodsQueryPageDto)
            this.cpflgetlist()
         },
         sjhsearchFor(){
             // this.soldGoodsQueryPageDto.phone = type
             this.getlist(this.soldGoodsQueryPageDto)
          },
         dels(e) {
            this.$confirm('是否确认删除?', '提示', {
               confirmButtonText: '确定',
               cancelButtonText: '取消',
               type: 'warning'
            }).then(() => {
               this.$api.sccphpjexpurgate({
               goodsId:e.goodsId,
               goodsType:this.soldGoodsQueryPageDto.goodsType
                  }).then((res) => {
                  if(res.data.code==200){
                     this.getlist(this.soldGoodsQueryPageDto)
                     this.$message.success(res.data.message)
                  }else{
                     this.$message.error(res.data.message)
                  }
               })
            }).catch(() => {
               this.$message({
                  type: 'info',
                  message: '已取消删除'
               });          
            });
         },
         plhandleClick(type){
            let pllist = []
            type.forEach(element => {
               pllist.push(element.goodsId)
            });
            if (pllist.length>0) {
               this.dataSet= false
            }else{
               this.dataSet= true
            }
            this.upGoodsBatchDto.goodsIds = pllist
         },
         newoktypes(){
            this.upGoodsBatchDto.goodsType = this.soldGoodsQueryPageDto.goodsType
            this.$confirm('是否确认上架?', '提示', {
                 confirmButtonText: '确定',
                 cancelButtonText: '取消',
                 type: 'warning'
               }).then(() => {
                 this.$api.plsjupGoodsBatch(this.upGoodsBatchDto).then((res) => {
                     if(res.data.code==200){
                        this.$message.success(res.data.message)
                        this.getlist(this.soldGoodsQueryPageDto)
                     }else{
                        this.$message.error(res.data.message)
                     }
                 })
               }).catch(() => {
                 this.$message({
                   type: 'info',
                   message: '已取消'
                 });          
               });
         },
         bianjiClick(e) {
            this.$router.push({
               path: "producaddtadetail",
               query: {
                  productId: e.goodsId,
               },
            });
         },
         xjpjbianjiClick(e) {
            this.$router.push({
               path: "adetailsaccessories",
               query: {
                  partsId: e.goodsId,
               },
            });
         },
         handleCurrentChange(val) {
            this.soldGoodsQueryPageDto.pageNum = val
             this.getlist(this.queryMaterialDto)
         },
         handleSizeChange(val) {
            this.soldGoodsQueryPageDto.pageSize = val
             this.getlist(this.queryMaterialDto)
         },
         }
      }
   </script>
   <style scoped>
   #removefrom {
      width: 100%;
      height: 100%;
      overflow-y: auto;
      background-color: #fff;
      padding:0 0 0 30px;
      box-sizing: border-box;
   }
   .tos {
      display: flex;
      /* justify-content: space-between; */
      align-items: center;
      /* background: yellow; */
      margin-bottom: 20px;
      margin-left: -15px;
    }
    .elrow{
      box-sizing: border-box;
      width: 20%;
      margin-top: -6px;
      margin: 0 40px 0 20px;
    }
    .elrowleft{
      width: 80%;
      float: left;
      box-sizing: border-box;
    }
    .elrowleft input{
      border: 2px solid #1b93ed !important;
      border-radius: 0 !important;
      width: 100%;
      -webkit-appearance: none;
      appearance: none;
      background-color: #fff;
      background-image: none;
      border-radius: 4px;
      border: 1px solid #929da5;
      box-sizing: border-box;
      color: #1f3d35;
      font-size: 14px;
      height: 36px;
      line-height: 1;
      outline: none;
      padding: 3px 10px;
      transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    }
    .elrowcontent{
      width: 16.66667%;
      float: left;
      box-sizing: border-box;
    }
    .search-btn {
      height: 36px;
      width: 100px;
      background: #1b93ed;
      border: 2px solid #1b93ed;
      margin: 0;
      padding: 0;
      color: #fff;
      cursor: pointer;
    }
    .zdjsdd{
      margin-bottom:20px
    }
    .zdjsdd /deep/ .el-form-item{
      margin-bottom :10px !important;
    }
    .has-border{
      border-bottom: 1px solid#DCDCDC;
    }
    .tjannos{
      display: flex;
      margin-bottom: 20px;
    }
    .right-item {
      margin-left: auto;
    }
    .tos /deep/ .el-form-item {
        margin-bottom: 0 !important;
    }
    .form-input-wrapper {
     display: flex;
     align-items: center;
   }
   .input-field {
     flex: 1; /* 输入框占据剩余空间 */
     margin-right: 10px; /* 输入框和按钮之间的间距 */
   }
   .submit-button {
     margin-left: 10px;
   }
    .btnbox {
          /* background: pink; */
          display: flex;
          width: 40%;
          align-items: center;
          justify-content: space-around;
          margin: auto;
          margin-top: 30px;
      }
      .zcyhtk /deep/ .el-form-item__label {
       width: 90px !important;
     }
     .zcyhtk /deep/ .el-form-item__content {
       margin-left: 90px !important;
     }
   </style>


// WEBPACK FOOTER //
// src/components/management/removefrom.vue